import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg, tokens } from "@/lib/api";

const blank = { current_password: "", new_password: "", confirm: "" };

export function ChangePasswordCard() {
  const [f, setF] = useState(blank);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 8) return toast.error("New password must be at least 8 characters");
    if (f.new_password !== f.confirm) return toast.error("New passwords don't match");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      tokens.set(data.tokens);
      toast.success("Password changed");
      setF(blank);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  const field = (k, label) => (
    <div className="space-y-1.5">
      <Label htmlFor={k}>{label}</Label>
      <Input id={k} type="password" required autoComplete={k === "current_password" ? "current-password" : "new-password"}
        value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="h-10" data-testid={`change-password-${k.replace("_", "-")}-input`} />
    </div>
  );

  return (
    <section className="rounded-2xl border bg-white p-6 sm:p-7" data-testid="change-password-card">
      <div className="flex items-center gap-2 mb-1">
        <KeyRound className="h-4 w-4 text-primary" />
        <h2 className="text-lg font-semibold">Change password</h2>
      </div>
      <p className="text-sm text-slate-500 mb-5">Use at least 8 characters. You'll stay signed in on this device.</p>
      <form onSubmit={submit} className="grid sm:grid-cols-3 gap-4 items-end">
        {field("current_password", "Current password")}
        {field("new_password", "New password")}
        {field("confirm", "Confirm new password")}
        <div className="sm:col-span-3">
          <Button type="submit" className="rounded-full px-6" disabled={busy} data-testid="change-password-submit-button">
            {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Update password
          </Button>
        </div>
      </form>
    </section>
  );
}
